import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

/**
 * Custom hook to extract school and school group data based on current route
 * @returns {Object} - Contains school, schoolGroup, schools array, and isSchoolsTrainingPage flag
 */
export default function useSchoolData() {
    const { pathname } = useLocation();
    const isSchoolsTrainingPage = pathname?.split('/')?.[1] === 'school-aanbod';

    const schoolGroups = useSelector((state) =>
        state?.school?.entities?.allIds?.map(
            (id) => state?.school?.entities?.byId[id]
        )
    );

    const schools = [];
    schoolGroups.forEach((g) => g?.schools?.forEach((s) => schools?.push(s)));

    const school = isSchoolsTrainingPage
        ? schools?.find(
              (s) =>
                  isSchoolsTrainingPage &&
                  s.training_url === pathname?.split('/')?.[2]
          )
        : null;

    const schoolGroup = schoolGroups.find(
        (s) =>
            isSchoolsTrainingPage &&
            s.training_url === pathname?.split('/')?.[2]
    );

    return {
        school,
        schoolGroup,
        schools,
        schoolGroups,
        isSchoolsTrainingPage,
    };
}
